import { Badge, Box, Flex, Text } from '@chakra-ui/react'
import { FieldMapValue, RiskAssessment } from '@hb/shared'
import { SectionLabel } from '../../SectionLabel'

const riskColorScheme: Record<RiskAssessment, string> = {
  'no-risk': 'green',
  risk: 'red',
  'further-evaluation-needed': 'orange',
}

const riskLabel: Record<RiskAssessment, string> = {
  'no-risk': 'No Risk',
  risk: 'Risk',
  'further-evaluation-needed': 'Further Evaluation Needed',
}

export const RiskAssessmentView = ({ data }: { data: FieldMapValue }) => {
  const value = data?.riskAssessment as RiskAssessment | undefined
  return (
    <Box w="100%">
      <Flex align="center" gap={3}>
        <SectionLabel>Risk Assessment</SectionLabel>
        {value ? (
          <Badge colorScheme={riskColorScheme[value]} fontSize="sm" px={2} py={0.5}>
            {riskLabel[value]}
          </Badge>
        ) : (
          <Text fontStyle="italic" color="gray.500" fontSize="sm">
            Not recorded
          </Text>
        )}
      </Flex>
    </Box>
  )
}
